export default __webpack_public_path__ + "static/media/mithril.57eaae7e.jpeg";